export default __webpack_public_path__ + "assets/img/line-awesome.6e3d85921cc783ab409b8f9a95363f44.svg";